var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM9.5 7.97771C9.5 7.85871 9.596 7.74971 9.728 7.74971H12.546C14.021 7.74971 15.233 8.94871 15.233 10.4007C15.233 11.8877 14.021 13.0997 12.558 13.0997H11.059V15.9177C11.059 16.0367 10.951 16.1457 10.831 16.1457H9.728C9.596 16.1457 9.5 16.0367 9.5 15.9177V7.97771ZM12.498 11.6357C13.17 11.6357 13.685 11.0967 13.685 10.3887C13.685 9.72971 13.17 9.22571 12.498 9.22571H11.059V11.6357H12.498Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkWhite);
export default __webpack_public_path__ + "static/media/park-white.a3b0b70b409be4fa0c729b444dcef826.svg";
export { ForwardRef as ReactComponent };